webpackJsonp([57],{

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1003);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("010b56e4", content, true);

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.w-btn[data-v-114457f3]{width:125px!important}.color-green[data-v-114457f3]{color:#4dc68c!important}.bold[data-v-114457f3]{font-family:Lato_regular;font-weight:700}.color-red[data-v-114457f3]{color:#f52c18!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/process/configuration-process.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,wBACE,qBAAwB,CACzB,AACD,8BACE,uBAA0B,CAC3B,AACD,uBACE,yBAA4B,AAC5B,eAAkB,CACnB,AACD,4BACE,uBAA0B,CAC3B","file":"configuration-process.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.w-btn[data-v-114457f3] {\n  width: 125px !important;\n}\n.color-green[data-v-114457f3] {\n  color: #4dc68c !important;\n}\n.bold[data-v-114457f3] {\n  font-family: \"Lato_regular\";\n  font-weight: bold;\n}\n.color-red[data-v-114457f3] {\n  color: #f52c18 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showParentView('page-configuration-process'))?_c('div',[_c('section',[_c('header-page',{attrs:{"name":"configuration","title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"px-5 pb-5 mb-5"},[_c('app-table',{staticClass:"mt-5",attrs:{"columns":_vm.columns,"rows":_vm.rows,"last-page":_vm.lastPage,"current-page":_vm.currentPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v(_vm._s(props.row.code))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v(_vm._s(props.row.scope))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v(_vm._s(props.row.moduleName))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_c('span',{class:props.row.flagSelected === true ? 'color-green bold' : 'color-red bold'},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.row.flagSelected ? 'Activo' : 'Inactivo')+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_c('app-tooltip-button',{attrs:{"color":"blue","icon":"build","text":"Asignar Categorías"},on:{"click-icon":function($event){_vm.openProcess(props.row)}}})],1)]}}])})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('section',{staticClass:"modal-filter-footer"},[_c('v-layout',{attrs:{"xs12":"","justify-center":"","pt-4":"","pb-4":""}},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},nativeOn:{"click":function($event){return _vm.returnListTemplate($event)}}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t\t"),_c('img',{staticClass:"ml-2",attrs:{"src":(_vm.$imageUrl + "/icon-cancel.svg"),"alt":""}})]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action w-btn caption ml-1 pl-2 pr-2",attrs:{"color":"blue"},on:{"click":_vm.openAssign}},[_vm._v("\n\t\t\t\t\tAsignar Integración\n\t\t\t\t")])],1)],1)]),_vm._v(" "),_c('router-view')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_process_vue__ = __webpack_require__(821);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114457f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_process_vue__ = __webpack_require__(1004);
function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114457f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114457f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);



var loadProcess = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: this.params.page,
							perPage: this.params.perPage,
							templateCode: this.$route.params.codeTemplate,
							projectCode: this.$route.params.codeProject
						};
						_context.next = 3;
						return this.$http.get('process', { params: params });

					case 3:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadProcess() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadProcess();
}

function openProcess(_ref2) {
	var id = _ref2.id;

	this.goTo('page-configuration-process-integration-category', { params: { idProcess: id } });
}

function closeModal() {
	this.openAction = false;
}

function openAssign() {
	this.goTo('page-configuration-process-assign');
}

function changePage(page) {
	this.currentPage = page;
	this.loadProcess();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadProcess();
}

function returnListTemplate() {
	this.goTo('page-template');
}

function data() {
	return {
		openAction: false,
		columns: [{ id: 1, name: 'Código', value: 'code', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Alcance', value: 'scope', checked: true, visible: true }, { id: 4, name: 'Modulo', value: 'module', checked: true, visible: true }, { id: 5, name: 'Estado', value: 'value', checked: true, visible: true }, { id: 6, name: 'Acciones', value: 'name', checked: true, visible: true }],
		currentPage: 0,
		lastPage: 0,
		title: 'Configurar Procesos',
		selectedValue: 'flagSelected',
		rows: [],
		params: {
			perPage: 10,
			page: 1,
			search: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-configuration-process',
	data: data,
	created: created,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		changePage: changePage,
		closeModal: closeModal,
		loadProcess: loadProcess,
		openAssign: openAssign,
		openProcess: openProcess,
		onSearch: onSearch,
		returnListTemplate: returnListTemplate
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-configuration-process') {
					this.loadProcess();
				}
			}
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/57.9c4c226e61afde6bfc1d.js